import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import ArrowupIcon from 'icons/Arrowup.icon';
import ArrowdownIcon from 'icons/Arrowdown.icon';
import MultiSortModal from 'components/MultiSortModal';
import { OptionValue } from 'ncoded-component-library/build/components/molecules/Select/Select.component';
import { SortingDirectionValues } from 'models/Sort';

import './MultiSort.styles.scss';

type MultiSortProps = {
  className?: string;
  multiSortValues: OptionValue<string>[];
  multiSortDirectionTranslation?: SortingDirectionValues;
};

const MultiSort: React.FC<MultiSortProps> = (props) => {
  const { className, multiSortValues, multiSortDirectionTranslation } = props;

  const [multiSort, multiSortRef] = useCallbackRef<ModalRef>();

  const classes = classNames('multi-sort', className);

  return (
    <>
      <Button
        className={classes}
        variant="icon"
        icon={
          <>
            <ArrowupIcon />
            <ArrowdownIcon />
          </>
        }
        onClick={multiSort?.open}
      />
      <MultiSortModal
        ref={multiSortRef}
        options={multiSortValues}
        sortDirectionTranslations={multiSortDirectionTranslation}
      />
    </>
  );
};

export default MultiSort;
